<template>
  <header class="page-block header-block" id="header-block">
    <div class="wide">
      <div class="mid">
        <nav class="left">
          <a href="#services-block" class="menu-item">
            <div class="nav-service">
              <img class="service-1" src="@/i/header/nav/service-1.svg" alt="Balls barbershop">
              <img class="service-2" src="@/i/header/nav/service-2.svg" alt="Balls barbershop">
            </div>
            <span>{{ $t('MainMenu.Services') }}</span>
          </a>
          <a href="#barbers-block" class="menu-item">
            <div class="nav-barber">
              <img class="barber-1" src="@/i/header/nav/barber-1.svg" alt="Balls barbershop">
              <img class="barber-2" src="@/i/header/nav/barber-2.svg" alt="Balls barbershop">
            </div>
            <span>{{ $t('MainMenu.Barbers') }}</span>
          </a>
        </nav>
        <nav class="right">
          <a href="#products-block" class="menu-item">
            <div class="nav-products">
              <img class="products-1" src="@/i/header/nav/products-1.svg" alt="Balls barbershop">
              <div>
                <img class="products-2" src="@/i/header/nav/products-2.svg" alt="Balls barbershop">
                <img class="products-3" src="@/i/header/nav/products-3.svg" alt="Balls barbershop">
              </div>
            </div>
            <span>{{ $t('MainMenu.Products') }}</span>
          </a>
          <a href="#contacts-block" class="menu-item">
            <div class="nav-contacts">
              <img class="contacts-1" src="@/i/header/nav/contacts-1.svg" alt="Balls barbershop">
              <img class="contacts-2" src="@/i/header/nav/contacts-2.svg" alt="Balls barbershop">
            </div>
            <span>{{ $t('MainMenu.Contacts') }}</span>
          </a>
        </nav>
        <div class="main-logo">
          <img src="@/i/header/main-logo.svg" alt="Balls barbershop">
        </div>
         <LanguageSwitcher />
      </div>
    </div>
  </header>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  components: {
    LanguageSwitcher,
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped >
</style>
